<template>
  <div>
    <form
      v-if="!success"
      @submit.prevent="sendForm(value)">
      <h4>{{ $t('New password') }}</h4>
      <hr>
      <div :class="{'box-loading': loading}">
        <div class="form-group">
          <label>{{ $t('New password') }}</label>
          <input
            v-autofocus
            type="password"
            class="form-control"
            v-model="value.password">
          <ValidateMessage :error="validateErrors.password" />
        </div>
        <div class="form-group">
          <label>{{ $t('Confirm password') }}</label>
          <input
            type="password"
            class="form-control"
            v-model="value.password_confirmation">
          <ValidateMessage :error="validateErrors.password_confirmation" />
        </div>
        <div>
          <button
            type="submit"
            class="btn btn-primary">{{ $t('Reset') }}</button>
        </div>
      </div>
    </form>
    <div v-if="success">
      <h3 class="text-success">{{ $t('The password has been successfully reset!')  }}</h3>
      <p>{{ $t('You will be redirected to the login page.') }}</p>
      <p><strong>{{ $t('Wait...') }}</strong></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordRedefined',
  components: {
  },
  data () {
    return {
      value: {
        password: '',
        password_confirmation: '',
        token: this.$route.params.token
      },
      loading: false,
      success: false,
      validateErrors: {}
    }
  },
  metaInfo () {
    return {
      title: this.$t('New password')
    }
  },
  created () {
  },
  methods: {
    sendForm (value) {
      this.loading = true

      this.$store
      .dispatch('authPasswordRedefined', value)
      .then((response) => {
        this.loading = false
        this.success = true
        setTimeout(() => {
          this.$router.push('/auth')
        }, 4000)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/PasswordRedefined.vue